module.exports = __webpack_public_path__ + "media/images/new_landing/logos/pepsi-5152777c40ece97544bdfc1e24c20282.png";